module.exports = __webpack_public_path__ + "img/signature_background_desktop.b3abdc5.jpg";